import { FormattedMessage } from 'react-intl'
import { NavLink } from 'react-router-dom'

import { CopyToClipboard, CopyToClipboardWrapper } from '@10xLabs/react-web/components/CopyToClipboard'
import { StyledLink } from 'components/v2/Link'
import { TableContainer, Table, Thead, Th, Tbody, Tr, Td } from 'components/v2/Table'
import { CartStatus } from 'features/Carts/components/Status'
import { canWriteCart } from 'features/Users/utils'
import { CartActions } from './Actions'
import { useLogin } from 'features/Login/hooks'
import { ReactElement } from 'react'
import { GTCart } from 'gql/types.generated'

export const CartsList = ({ carts = [] }: { carts: GTCart[] }): ReactElement => {
  const login = useLogin()
  const showCompany = login.isSuperAdmin

  return (
    <TableContainer overflow>
      <Table marginBottom>
        <Thead>
          <Tr>
            {canWriteCart(login.accessToken.policies) && <Th />}
            <Th>
              <FormattedMessage id="dictionary.id" defaultMessage="Id" />
            </Th>
            <Th>
              <FormattedMessage id="spanish.dictionary.name" defaultMessage="Nombre" />
            </Th>
            <Th>
              <FormattedMessage id="spanish.dictionary.status" defaultMessage="Estado" />
            </Th>
            {showCompany && (
              <Th>
                <FormattedMessage id="spanish.dictionary.companies" defaultMessage="Compañías" />
              </Th>
            )}
          </Tr>
        </Thead>
        <Tbody>
          {carts.map((cart: TSFixMe): TSFixMe => {
            return (
              <Tr key={cart.id}>
                {canWriteCart(login.accessToken.policies) && (
                  <Td>
                    <CartActions cart={cart} />
                  </Td>
                )}
                <Td>
                  <CopyToClipboardWrapper>
                    <div>{cart.id.substring(0, 8)}</div>

                    <CopyToClipboard str={cart.id} />
                  </CopyToClipboardWrapper>
                </Td>
                <Td>
                  <StyledLink as={NavLink} to={`/carts/${cart.id}/items`}>
                    {cart.name}
                  </StyledLink>
                </Td>
                <Td>
                  <CartStatus status={cart.status} />
                </Td>
                {showCompany && (
                  <Td>
                    {cart.companies.map(
                      (company: TSFixMe): TSFixMe => (
                        <div key={company.id}>{company.name}</div>
                      )
                    )}
                  </Td>
                )}
              </Tr>
            )
          })}
        </Tbody>
      </Table>
    </TableContainer>
  )
}
